/* derw-desktop.js | wholesale.dryeyerescue.com, 2 Oct 2026
   Companion to assets/derw-desktop.css, section 2.

   In the collection LIST view, gives each one-variant product a quantity box
   beside its Add to cart button. The theme's form already carries a hidden
   <input name="quantity" value="1">; this keeps that input in step with the
   visible box, so the theme's own add-to-cart path does the adding exactly as
   before. Nothing else about the form changes.

   Runs again whenever the theme re-renders the product list (filters,
   sorting, switching between grid and list), and does nothing on phones,
   where the stylesheet hides the box. */
(function () {
  if (window.__derwListQty) return;
  window.__derwListQty = true;

  function wire(scope) {
    (scope || document).querySelectorAll('.product-item--list form[action*="/cart/add"]').forEach(function (form) {
      if (form.querySelector('.derw-list-qty')) return;
      var hidden = form.querySelector('input[name="quantity"]');
      var add = form.querySelector('[data-action="add-to-cart"]');
      if (!hidden || !add) return;
      var box = document.createElement('input');
      box.type = 'number';
      box.min = '1';
      box.value = hidden.value || '1';
      box.inputMode = 'numeric';
      box.className = 'derw-list-qty';
      var title = form.closest('.product-item');
      title = title && title.querySelector('.product-item__title');
      box.setAttribute('aria-label', 'Quantity' + (title ? ' for ' + title.textContent.trim() : ''));
      var sync = function () {
        var n = Math.max(1, parseInt(box.value, 10) || 1);
        hidden.value = n;
      };
      box.addEventListener('input', sync);
      box.addEventListener('change', function () { sync(); box.value = hidden.value; });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); sync(); add.click(); }
      });
      /* Re-sync on click too, in case the theme resets the hidden field after an add. */
      add.addEventListener('click', sync, true);
      add.parentNode.insertBefore(box, add);
    });
  }

  function start() {
    if (!document.querySelector('.product-list')) return;   /* collection and search pages only */
    wire(document);
    /* The theme replaces the whole collection section on filter, sort and
       grid/list changes, so a watcher on the section dies with it. Watch the
       body instead, look only at mutations that add elements, and batch
       bursts into one pass per frame. */
    var queued = false;
    new MutationObserver(function (records) {
      if (queued) return;
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            queued = true;
            requestAnimationFrame(function () { queued = false; wire(document); });
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
